import { gql } from '@apollo/client';

const MARK_STATUS_REPORT = gql`
  mutation markStatusReport($input: MarkStatusReportInput) {
    markStatusReport(input: $input) {
      isSuccess
      message
    }
  }
`;

export default MARK_STATUS_REPORT;
